import axios from 'axios'
import { toast as notifyToast } from 'react-toastify'

let toastSuppressionInterval = null
let toastSuppressionTimeout = null

const safeParse = (value) => {
  if (!value) return null

  try {
    return JSON.parse(value)
  } catch {
    return null
  }
}

export const getStoredAuthSessions = () => ({
  adminInfo: safeParse(localStorage.getItem('adminInfo')),
  userInfo: safeParse(localStorage.getItem('userInfo')),
})

export const clearStoredAuthSessions = () => {
  ;['adminInfo', 'userInfo', 'token', 'userToken', 'tempUserInfo'].forEach((key) =>
    localStorage.removeItem(key),
  )
}

const dismissAllToasts = () => {
  notifyToast.dismiss()
  if (typeof notifyToast.clearWaitingQueue === 'function') {
    notifyToast.clearWaitingQueue()
  }
}

export const suppressToastsAfterLogout = (durationMs = 2000) => {
  dismissAllToasts()

  if (toastSuppressionInterval) {
    clearInterval(toastSuppressionInterval)
  }

  if (toastSuppressionTimeout) {
    clearTimeout(toastSuppressionTimeout)
  }

  const startedAt = Date.now()
  toastSuppressionInterval = setInterval(() => {
    if (Date.now() - startedAt >= durationMs) {
      clearInterval(toastSuppressionInterval)
      toastSuppressionInterval = null
      return
    }

    dismissAllToasts()
  }, 150)

  toastSuppressionTimeout = setTimeout(() => {
    dismissAllToasts()

    if (toastSuppressionInterval) {
      clearInterval(toastSuppressionInterval)
      toastSuppressionInterval = null
    }

    toastSuppressionTimeout = null
  }, durationMs)
}

const sendLogoutRequest = async (baseUrl, route, token) => {
  if (!baseUrl || !token) return

  try {
    await axios.post(
      `${baseUrl}${route}`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    )
  } catch (error) {
    const status = error.response?.status

    // If the token is already invalid, logout can continue locally.
    if (status === 401 || status === 403) {
      return
    }

    console.warn(
      `Logout request failed for ${route}:`,
      error.response?.data?.message || error.message,
    )
  }
}

export const invalidateServerSessions = async (baseUrl, sessions = {}) => {
  const requests = []

  if (sessions.adminInfo?.token) {
    requests.push(sendLogoutRequest(baseUrl, '/admins/logout', sessions.adminInfo.token))
  }

  if (sessions.userInfo?.token) {
    requests.push(sendLogoutRequest(baseUrl, '/users/logout', sessions.userInfo.token))
  }

  await Promise.all(requests)
}
